<form [formGroup]="form" (ngSubmit)="submit()">
  <h2 mat-dialog-title>{{ "tpda.emails.list" | translate }}</h2>
  <mat-dialog-content>
    <mat-form-field
      class="full-width"
      [class.mat-form-field-invalid]="form.invalid && (form.get('emails')?.touched || form.get('emails')?.dirty)"
    >
      <mat-label>{{ "tpda.emails.list" | translate }}</mat-label>
      <mat-chip-list #chipList aria-label="Emails list">
        <mat-chip *ngFor="let email of form.get('emails')!.value" selectable removable (removed)="removeEmail(email)">
          {{ email }}
          <mat-icon matChipRemove>cancel</mat-icon>
        </mat-chip>

        <input
          placeholder="{{ 'tpda.emails.add' | translate }}"
          [matChipInputFor]="chipList"
          [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
          (matChipInputTokenEnd)="addEmail($event)"
        />
      </mat-chip-list>

      <mat-hint>{{ "tpda.emails.hint" | translate }}</mat-hint>

      <mat-error *ngIf="form.get('emails')?.hasError('requireOne')"> {{ "tpda.emails.atLeastOne" }} </mat-error>
      <mat-error *ngIf="form.get('emails')?.hasError('invalidEmail')"> {{ "tpda.emails.mustBeValid" }} </mat-error>
    </mat-form-field>
  </mat-dialog-content>
  <mat-dialog-actions>
    <button mat-raised-button color="primary" type="submit" [disabled]="form.invalid || isSubmitting">
      {{ "btn.send" | translate }}
    </button>
  </mat-dialog-actions>
</form>
